/**
 * Twemoji tabanlı emoji renderer.
 * Tüm Unicode emoji karakterlerini Twemoji CDN resimleriyle değiştirir.
 *
 * twemoji.parse(string) → HTML string döndürür (DOM manipülasyonu yok).
 * dangerouslySetInnerHTML ile render edilir, React reconciliation ile çakışmaz.
 */
import React, { memo } from 'react';
import * as _twemojiModule from 'twemoji';
// twemoji v14 ESM has `export default twemoji`; CJS webpack interop wraps it differently
const twemoji = _twemojiModule?.default || _twemojiModule;

const TWEMOJI_OPTS = {
  base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/',
  folder: '72x72',
  ext: '.png',
  className: 'twemoji',
};

/**
 * Metni Twemoji ile render eden React component.
 * Kullanım: <TwemojiText text="Merhaba 😀" />
 */
export const TwemojiText = memo(({ text, className, style }) => {
  if (text === null || text === undefined) return null;

  const html = twemoji.parse(String(text), TWEMOJI_OPTS);

  return (
    <span
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
});

TwemojiText.displayName = 'TwemojiText';

/**
 * Geriye dönük uyumluluk için — artık TwemojiText kullanın.
 */
export function renderWithAppleEmoji(text) {
  if (!text || typeof text !== 'string') return text;
  return <TwemojiText text={text} />;
}
